import React, { ReactElement } from "react";

import FrequentlyAskedQuestion from "components/FrequentlyAskedQuestion";
import { addEditAttributes } from "utils/episerver";

import FrequentlyAskedQuestionListProps from "./FrequentlyAskedQuestionListProps";

const FrequentlyAskedQuestionList = ({
    label,
    questions,
    identifier,
    anchorName,
}: FrequentlyAskedQuestionListProps): ReactElement => {
    return (
        <div aria-label={label} {...addEditAttributes("Questions")}>
            {questions?.map((faqItem, index) => {
                return (
                    <FrequentlyAskedQuestion
                        key={`Faq${index}`}
                        {...faqItem}
                        id={
                            anchorName
                                ? `${anchorName}-${index}`
                                : identifier
                                  ? `${identifier}-${index}`
                                  : `faq-${index}`
                        }
                    />
                );
            })}
        </div>
    );
};

export default React.memo(FrequentlyAskedQuestionList);
